/// <amd-module name="Artifacts/Root/helpers/HtmlHelper" />
export function htmlEncode(str: string): string {
  // we can write a slightly faster (30%) version that uses a regexp to find and replace
  // all occurences of [&<>"] by their corresponding HTML entities but this approach
  // uses the DOM implementation, so presumably it covers all input/edge cases.

  const div = document.createElement("div");
  div.appendChild(document.createTextNode(str));

  // The trick we are using here doesnt encode quotes. So we have to replace them using regexp search
  return div.innerHTML.replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

export function htmlDecode(str: string): string {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = str;
  return textArea.innerHTML;
}
